/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Launch_HubInputs */

const en_nfp_launch_hub = /** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize Your NFP Hub`)
};

const es_nfp_launch_hub = /** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializar Hub de ONG`)
};

const fr_nfp_launch_hub = /** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialiser votre Hub NFP`)
};

const de_nfp_launch_hub = /** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deinen NFP-Hub initialisieren`)
};

const id_nfp_launch_hub = /** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi Hub NFP Anda`)
};

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const ja_nfp_launch_hub = en_nfp_launch_hub;

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const zh_nfp_launch_hub = en_nfp_launch_hub;

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const ar_nfp_launch_hub = en_nfp_launch_hub;

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const it_nfp_launch_hub = en_nfp_launch_hub;

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const ru_nfp_launch_hub = en_nfp_launch_hub;

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const pt_nfp_launch_hub = en_nfp_launch_hub;

/** @type {(inputs: Nfp_Launch_HubInputs) => LocalizedString} */
const ko_nfp_launch_hub = en_nfp_launch_hub;

/**
* | output |
* | --- |
* | "Initialize Your NFP Hub" |
*
* @param {Nfp_Launch_HubInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_launch_hub = /** @type {((inputs?: Nfp_Launch_HubInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Launch_HubInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_launch_hub(inputs)
	if (locale === "es") return es_nfp_launch_hub(inputs)
	if (locale === "fr") return fr_nfp_launch_hub(inputs)
	if (locale === "de") return de_nfp_launch_hub(inputs)
	if (locale === "ja") return ja_nfp_launch_hub(inputs)
	if (locale === "zh") return zh_nfp_launch_hub(inputs)
	if (locale === "ar") return ar_nfp_launch_hub(inputs)
	if (locale === "id") return id_nfp_launch_hub(inputs)
	if (locale === "it") return it_nfp_launch_hub(inputs)
	if (locale === "ru") return ru_nfp_launch_hub(inputs)
	if (locale === "pt") return pt_nfp_launch_hub(inputs)
	return ko_nfp_launch_hub(inputs)
});